/* eslint-disable ember/no-controller-access-in-routes, ember/no-get, ember/no-runloop, warp-drive/no-legacy-request-patterns */
import Route from '@ember/routing/route';
import { get } from '@ember/object';
import { next } from '@ember/runloop';
import { service } from '@ember/service';
import { hash } from '@linc-technologies/linced-common/utils/promise';

export default class LedgerRoute extends Route {
  queryParams = {
    from: {
      refreshModel: true,
    },
    to: {
      refreshModel: true,
    },
  };

  // Services
  @service
  store;

  model(params) {
    return hash({
      ledger: this.store.findRecord('finance/ledger', params.ledger_id),
      ledgerItems: this.store.query('finance/ledger-item', {
        ledgerId: params.ledger_id,
      }),
      transactions: this.store
        .query('finance/transaction', {
          ledgerId: params.ledger_id,
          dateFrom: params.from,
          dateTo: params.to,
          include: 'accounts,lineItems,sourceTransactions',
        })
        .then((transactions) =>
          transactions.filter(
            (transaction) =>
              get(transaction, 'lineItem.ledger.id') === params.ledger_id,
          ),
        ),
    });
  }

  activate() {
    super.activate(...arguments);
    next(this, function () {
      this.controllerFor('application').set('isWideList', true);
    });
  }

  deactivate() {
    super.deactivate(...arguments);
    next(this, function () {
      this.controllerFor('application').set('isWideList', false);
    });
  }

  resetController(controller) {
    controller.reset();
  }
}
